import Marquee from "react-fast-marquee";
import { Reveal } from "@/components/common/Reveal";

// Logos partenaires / recruteurs fournis par le client.
const COMPANIES = [
  { name: "Transdev", src: "https://customer-assets-v7afamib.emergentagent.net/job_educaser-dev/artifacts/99kp2zio_tra-logo-transparent-png-1.webp" },
  { name: "GEODIS", src: "https://customer-assets-v7afamib.emergentagent.net/job_educaser-dev/artifacts/wjw21d19_Geodis-Logo-2021.png" },
  { name: "ECF", src: "https://customer-assets-v7afamib.emergentagent.net/job_educaser-dev/artifacts/1mewwjux_xbrmzz0mofbtrkxognim.webp" },
  { name: "Keolis", src: "https://customer-assets-v7afamib.emergentagent.net/job_educaser-dev/artifacts/j3pzhgam_Bouton_Keolis.png" },
  { name: "Transgourmet", src: "https://customer-assets-v7afamib.emergentagent.net/job_educaser-dev/artifacts/a58y5vos_Logo_Transgourmet.webp" },
];

export default function TrustedBy() {
  return (
    <section className="overflow-hidden bg-white py-20 lg:py-28" data-testid="trusted-by">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-8">
        <Reveal className="text-center">
          <h2 className="font-display text-3xl font-black uppercase tracking-tight text-brand-blue sm:text-4xl">
            Vous serez entre de bonnes mains
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-slate-500">
            Nos formations préparent aux besoins des entreprises de transport, des auto-écoles et
            des groupes qui recrutent nos diplômés.
          </p>
        </Reveal>
      </div>

      <div className="mt-14">
        <Marquee speed={40} gradient={false} pauseOnHover autoFill>
          {COMPANIES.map((c) => (
            <div key={c.name} className="mx-10 flex items-center justify-center sm:mx-14">
              <img
                src={c.src}
                alt={c.name}
                loading="lazy"
                className="max-h-12 w-auto max-w-[150px] object-contain transition-transform duration-300 hover:scale-105 sm:max-h-16 sm:max-w-[170px]"
              />
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
